import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild } from '@angular/core';
import { RouteInfo } from './sidebar.metadata';
import {RouterModule } from '@angular/router';
import { CommonModule, NgIf } from '@angular/common';
import { ROUTES } from 'src/app/sidebar/menu-items';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AddTansactionsComponent } from '../transaction/add-transactions/add-transactions.component';
import { UploadBankComponent } from '../transaction/upload-bank/upload-bank.component';
import { AddEditEntityComponent } from '../entities/add-edit-entity/add-edit-entity.component';
import { UploadMt103Component } from '../mt103/components/upload-mt103/upload-mt103.component';
@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [RouterModule, CommonModule, NgIf],
  templateUrl: './sidebar.component.html',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SidebarComponent implements OnInit {
  showMenu = '';
  showSubMenu = '';
  isClassAdded = false;
  public sidebarnavItems: RouteInfo[] = [];

  @ViewChild('projctModal') projctModal: any;

  constructor(
    private modalService: NgbModal,

  ) {}

  callModal(element: any) {

    if (element?.title === 'Upload Bank') {
      const modalRef = this.modalService.open(UploadBankComponent, {
        backdrop: true,
        windowClass: 'upload-bank-custom-model',
      });
    }

    if (element?.title === 'Upload MT103') {
      const modalRef = this.modalService.open(UploadMt103Component, {
        backdrop: true,
        windowClass: 'upload-bank-custom-model',
      });
    }

  if(element?.title === 'Add Entity'){
    const modalRef = this.modalService.open(AddEditEntityComponent, {
      backdrop: true,
      windowClass: 'add-entitty-custom-model custom_popup'
    });
    // modalRef.componentInstance.name = element?.title;
  }
  }
  


  ngOnInit() {
    this.sidebarnavItems = ROUTES.filter((sidebarnavItem) => sidebarnavItem);
  }
}
